<template>
  <div v-show="$store.state.auth.user.value1 !== 100" class="ev-add-log">
    <!-- Tab Switcher -->
    <div class="ev-tab-bar">
      <button
        class="ev-tab-btn"
        :class="{ 'ev-tab-btn--active': tabSelector === 0 }"
        @click="tabClicked(0)"
      >
        <span class="ev-tab-icon">✍️</span>
        Ručna prijava
      </button>
      <button
        class="ev-tab-btn"
        :class="{ 'ev-tab-btn--active': tabSelector === 1 }"
        @click="tabClicked(1)"
      >
        <span class="ev-tab-icon">📋</span>
        Kopiraj sa druge kartice
      </button>
    </div>

    <!-- Employee ID badge -->
    <div class="ev-add-log-id-bar">
      <span class="ev-badge ev-badge-secondary">
        👤 ID zaposlenog: <b>{{ employeeId }}</b>
      </span>
    </div>

    <!-- Remote Access Buttons -->
    <div v-show="isButtonsVisible" class="ev-quick-actions">
      <button
        class="ev-btn ev-btn-success ev-btn-sm"
        @click="startButtonClicked"
      >
        ▶️ Start
      </button>
      <button
        class="ev-btn ev-btn-primary ev-btn-sm"
        @click="pauseButtonClicked"
      >
        ⏸️ Pauza
      </button>
      <button class="ev-btn ev-btn-danger ev-btn-sm" @click="stopButtonClicked">
        ⏹️ Stop
      </button>
    </div>

    <!-- Tab Content -->
    <div v-show="isRadioVisible">
      <!-- ===== Tab 0: Ručna prijava ===== -->
      <div v-show="tabSelector === 0" class="ev-add-log-panel">
        <!-- Quick time buttons -->
        <div class="ev-time-shortcuts">
          <span class="ev-time-shortcuts-label">Brzo postavi vrijeme:</span>
          <button class="ev-btn ev-btn-primary ev-btn-sm" @click="addHours(7)">
            🕖 7h
          </button>
          <button class="ev-btn ev-btn-primary ev-btn-sm" @click="addHours(15)">
            🕐 15h
          </button>
        </div>

        <!-- DateTime Picker -->
        <div v-show="isCustomDateSelectorVisible" class="ev-add-log-picker">
          <label class="ev-filter-label">
            <span class="ev-filter-icon">⏰</span>
            Datum i vrijeme
          </label>
          <date-picker
            v-model="time3"
            @input="dateChosen"
            type="datetime"
            class="ev-date-picker"
          ></date-picker>
        </div>

        <!-- Action Selector -->
        <div class="ev-action-selector">
          <label class="ev-filter-label">
            <span class="ev-filter-icon">🎯</span>
            Ručno prijavi akciju
          </label>
          <div class="ev-radio-group">
            <label
              class="ev-radio-option"
              :class="{ 'ev-radio-option--active': action === '1' }"
            >
              <input
                type="radio"
                v-model="action"
                value="1"
                class="ev-radio-input"
              />
              <span class="ev-radio-icon">▶️</span>
              Start
            </label>
            <label
              class="ev-radio-option"
              :class="{ 'ev-radio-option--active': action === '2' }"
            >
              <input
                type="radio"
                v-model="action"
                value="2"
                class="ev-radio-input"
              />
              <span class="ev-radio-icon">⏸️</span>
              Pauza
            </label>
            <label
              class="ev-radio-option"
              :class="{ 'ev-radio-option--active': action === '3' }"
            >
              <input
                type="radio"
                v-model="action"
                value="3"
                class="ev-radio-input"
              />
              <span class="ev-radio-icon">⏹️</span>
              Stop
            </label>
          </div>
        </div>

        <!-- Submit -->
        <div class="ev-add-log-submit">
          <button
            class="ev-btn ev-btn-submit"
            :class="{ 'ev-btn-submit--disabled': action == null }"
            :disabled="action == null"
            @click="addRemoteClicked"
          >
            🚀 Pošalji prijavu ručno
          </button>
        </div>
      </div>

      <!-- ===== Tab 1: Kopiraj sa druge kartice ===== -->
      <div v-show="tabSelector === 1" class="ev-add-log-panel">
        <div class="ev-copy-card-section">
          <!-- Employee select -->
          <div class="ev-filter-group">
            <label class="ev-filter-label">
              <span class="ev-filter-icon">👤</span>
              Iskopiraj od druge kartice
            </label>
            <vue-select
              class="ev-select"
              @option:selected="employeeSelected"
              type="text"
              label="name"
              :clearable="false"
              :options="employees"
              v-model="selectedEmployee"
              placeholder="Izaberite zaposlenog..."
            />
          </div>

          <!-- Times display -->
          <div
            class="ev-copy-times"
            v-if="selectedEmployeeArrivalTime || selectedEmployeeDepartureTime"
          >
            <div class="ev-copy-time-item">
              <span class="ev-copy-time-label">📥 Dolazno vrijeme:</span>
              <span class="ev-copy-time-value">{{
                selectedEmployeeArrivalTime || "—"
              }}</span>
            </div>
            <div class="ev-copy-time-item">
              <span class="ev-copy-time-label">📤 Odlazno vrijeme:</span>
              <span class="ev-copy-time-value">{{
                selectedEmployeeDepartureTime || "—"
              }}</span>
            </div>
          </div>
        </div>

        <!-- Submit -->
        <div class="ev-add-log-submit">
          <button
            class="ev-btn ev-btn-danger"
            :disabled="
              !selectedEmployeeArrivalTime || !selectedEmployeeDepartureTime
            "
            @click="copyCardClicked"
          >
            📋 Iskopiraj
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import reportService from "../../services/report.service";

const { DateTime } = require("luxon");

export default {
  name: "AddLogManual",

  props: {
    employeeId: Number,
    date: Date,
    isCustomDateSelectorVisible: Boolean,
    isButtonsVisible: Boolean,
    isRadioVisible: Boolean,
    employees: Array,
    today: Date,
    tomorrow: Date,
  },

  components: {
    DatePicker,
  },

  data() {
    return {
      time3: Date,
      action: null,
      start: null,
      selectedEmployee: null,
      selectedEmployeeArrivalTime: null,
      selectedEmployeeDepartureTime: null,
      accessLogs: [],
      tabSelector: 0,
    };
  },

  mounted() {
    console.log("this.date");
    console.log(this.date);
    this.time3 = new Date(this.date);
  },

  methods: {
    dateChosen() {
      console.log(this.time3);
    },

    startButtonClicked() {
      console.log(this.employeeId);
      this.action = 1;
      var luxonStartDate = DateTime.now();
      this.start = luxonStartDate.toISO().split("+")[0];
      this.callReport(true);
    },

    pauseButtonClicked() {
      console.log(this.employeeId);
      this.action = 2;
      var luxonStartDate = DateTime.now();
      this.start = luxonStartDate.toISO().split("+")[0];
      this.callReport(true);
    },

    stopButtonClicked() {
      console.log(this.employeeId);
      this.action = 3;
      var luxonStartDate = DateTime.now();
      this.start = luxonStartDate.toISO().split("+")[0];
      this.callReport(true);
    },

    async addRemoteClicked() {
      console.log(this.employeeId);
      var luxonStartDate = DateTime.fromJSDate(this.time3);
      this.start = luxonStartDate.toISO().split("+")[0];
      await this.callReport(true);
    },

    async callReport(emitAccessRemoteCreatedEvent) {
      const response = await reportService.CreateNewAccessRemote({
        AccessTime: this.start,
        CompanyId: this.$store.state.general.companyId,
        EmployeeId: this.employeeId,
        UserId: this.$store.state.general.userId,
        EventId: this.action,
        ChoiceId: null,
        Note: "remote",
        Latitude: 0,
        Longitude: 0,
        Value1: null,
        String1: null,
      });

      console.log(response);
      if (emitAccessRemoteCreatedEvent)
        this.$emit("accessRemoteCreated", response);
    },

    async employeeSelected(emp) {
      console.log(emp);

      // let's find the start and end time for this date for this card
      const log = await reportService.GetNormalizedAccessDataByTimeRange(
        this.today, //new Date("2022-06-18T00:00:00"),
        this.tomorrow, //new Date("2022-06-19T00:00:00"),
        emp.id,
        null
      );

      this.action = null;

      console.log("Arival time general: ", log.data[0].arrivalTimeGeneral);
      console.log("Departure time general: ", log.data[0].departureTimeGeneral);

      this.selectedEmployeeArrivalTime = log.data[0].arrivalTimeGeneral;
      this.selectedEmployeeDepartureTime = log.data[0].departureTimeGeneral;
      this.accessLogs = log.data[0].myAccessLogs;
    },

    addHours(hours) {
      this.time3 = new Date(this.time3.setHours(this.date.getHours() + hours));
    },

    async copyCardClicked() {
      console.log(this.employeeId);

      console.log(this.accessLogs);

      // send via copyAccessLogs api
      let copiedLogs = await reportService.CopyAccessLogs({
        AccessLogs: this.accessLogs,
        EmployeeId: this.employeeId,
      });

      console.log(copiedLogs);

      this.$emit("accessRemoteCreated", copiedLogs);

      // console.log("Not implemented yet");

      // // first send arrival date
      // let luxonStartDate = DateTime.fromJSDate(
      //   new Date(this.selectedEmployeeArrivalTime)
      // );
      // this.start = luxonStartDate.toISO().split("+")[0];
      // this.action = 1;

      // console.log(this.start);
      // await this.callReport(false);

      // // then send departure date
      // luxonStartDate = DateTime.fromJSDate(
      //   new Date(this.selectedEmployeeDepartureTime)
      // );
      // this.start = luxonStartDate.toISO().split("+")[0];
      // this.action = 3;

      // console.log(this.start);
      // await this.callReport(true);
    },

    tabClicked(value) {
      this.tabSelector = value;
    },
  },
};
</script>

<style scoped>
/* Tab bar */
.ev-tab-bar {
  display: flex;
  gap: 4px;
  background: var(--ev-bg);
  border-radius: var(--ev-radius-lg);
  padding: 4px;
  margin-bottom: var(--ev-spacing-md);
}

.ev-tab-btn {
  flex: 1;
  padding: 10px 16px;
  border: none;
  border-radius: var(--ev-radius);
  background: transparent;
  color: var(--ev-text-muted);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.ev-tab-btn:hover {
  color: var(--ev-text-primary);
  background: white;
}

.ev-tab-btn--active {
  background: white;
  color: var(--ev-primary-start);
  box-shadow: var(--ev-shadow-sm);
}

.ev-tab-icon {
  font-size: 16px;
}

/* ID bar */
.ev-add-log-id-bar {
  margin-bottom: var(--ev-spacing-md);
}

/* Quick action buttons (Start/Pauza/Stop) */
.ev-quick-actions {
  display: flex;
  gap: 8px;
  margin-bottom: var(--ev-spacing-md);
}

/* Panel content area */
.ev-add-log-panel {
  background: var(--ev-bg);
  border-radius: var(--ev-radius-lg);
  padding: var(--ev-spacing-lg);
  border: 1px solid var(--ev-border);
}

/* Time shortcuts */
.ev-time-shortcuts {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: var(--ev-spacing-md);
  flex-wrap: wrap;
}

.ev-time-shortcuts-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--ev-text-muted);
}

/* Date picker group */
.ev-add-log-picker {
  margin-bottom: var(--ev-spacing-md);
  display: flex;
  flex-direction: column;
  gap: var(--ev-spacing-sm);
}

/* Action selector */
.ev-action-selector {
  margin-bottom: var(--ev-spacing-md);
  display: flex;
  flex-direction: column;
  gap: var(--ev-spacing-sm);
}

.ev-radio-group {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.ev-radio-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: 2px solid var(--ev-border);
  border-radius: var(--ev-radius);
  background: white;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: var(--ev-text-secondary);
  transition: all 0.2s ease;
  flex: 1;
  min-width: 120px;
  justify-content: center;
}

.ev-radio-option:hover {
  border-color: var(--ev-primary-start);
  background: #f5f3ff;
}

.ev-radio-option--active {
  border-color: var(--ev-primary-start);
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.08),
    rgba(118, 75, 162, 0.08)
  );
  color: var(--ev-primary-start);
}

.ev-radio-input {
  display: none;
}

.ev-radio-icon {
  font-size: 18px;
}

/* Submit area */
.ev-add-log-submit {
  margin-top: var(--ev-spacing-lg);
  display: flex;
  justify-content: flex-end;
}

.ev-btn-submit {
  padding: 14px 36px;
  font-size: 16px;
  font-weight: 700;
  border: none;
  border-radius: var(--ev-radius);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  background: var(--ev-danger-gradient);
  color: white;
}

.ev-btn-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
}

.ev-btn-submit--disabled,
.ev-btn-submit:disabled {
  background: var(--ev-border);
  color: var(--ev-text-muted);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Copy card section */
.ev-copy-card-section {
  margin-bottom: var(--ev-spacing-md);
}

.ev-copy-times {
  display: flex;
  gap: 16px;
  margin-top: var(--ev-spacing-md);
  flex-wrap: wrap;
}

.ev-copy-time-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: white;
  padding: 12px 16px;
  border-radius: var(--ev-radius);
  border: 1px solid var(--ev-border);
  flex: 1;
  min-width: 200px;
}

.ev-copy-time-label {
  font-size: 13px;
  color: var(--ev-text-muted);
  font-weight: 500;
}

.ev-copy-time-value {
  font-size: 14px;
  color: var(--ev-text-primary);
  font-weight: 700;
}
</style>